import { graphql } from 'react-relay';

export const QUserQuery = graphql`
query QUserQuery {
  user {
    id
    username
    email
    status
    roles
    userId
  }
  userTeam {
    id
    teamId
    apiKey
    name
    roles {
      role
      offerId
    }
    flexigets
    members {
      id
      user {
        id
        email
        roles
      }
      roles {
        role
        offerId
      }
      active
      dates {
        join
        lastConnection
      }
    }
  }
  teams {
    id
    name
    apiKey
    members {
      user {
        id
      }
      roles {
        role
        offerId
      }
    }
  }
} 
`;